"use client";
import { publicRuntimeValue } from "./public-runtime-config";

// WO-GF-001-P1B-S3 · Item 2 — ACCOUNT LINK-OUT (founder ruling 2026-07-21, INTERACTION-INVENTORY §4 scope
// call 2). The account area (guest trip lookup + signed-in My-Trips / My-Orders / profile) is NOT ported
// into apps/root — it lives in the existing, working accounts app. The chrome's signed-in account entries
// LINK OUT to it. Single source for those destinations so the popup (and any future chrome) stay coherent.
//
// The base URL is the app-boundary env the monorepo already defines (turbo globalEnv NEXT_PUBLIC_ACCOUNTS_URL;
// local dev = http://localhost:3000, prod = the accounts host). Read process.env directly (Next inlines
// NEXT_PUBLIC_* into the client bundle); fall back to the local dev host so a missing var degrades to a
// working local link rather than a broken "undefined/…". The accounts app uses next-intl `localePrefix:
// "as-needed"` with defaultLocale "en", so the default-locale paths carry no prefix (/trips, /my-orders,
// /account) — verified against apps/accounts route tree.
const accountsBase = () => (
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Preserve the existing empty-value fallback.
  publicRuntimeValue("NEXT_PUBLIC_ACCOUNTS_URL") || "http://localhost:3000"
).replace(/\/$/, "");

export function accountsUrl(path: string): string {
  return `${accountsBase()}${path.startsWith("/") ? path : `/${path}`}`;
}

/**
 * The canonical age-first Accounts sign-up (the brand Join), returning to `returnTo` — the exact Root page the
 * visitor joined from, so a booking, cart or sale page is not lost. Only an http(s) URL is carried, without its
 * fragment; Accounts re-checks it against its own approved origins (safeAuthReturn) and refuses anything else.
 */
export function accountsSignUpUrl(returnTo: string | null | undefined): string {
  let next = "";
  try {
    const url = new URL(returnTo ?? "");
    if (url.protocol === "https:" || url.protocol === "http:") {
      url.hash = "";
      next = `?next=${encodeURIComponent(url.href)}`;
    }
  } catch {
    /* not a URL: no return, Accounts uses its own default */
  }
  return accountsUrl(`/sign-up${next}`);
}

/** Guest booking lookup remains local; members open the full AccountKitShell orders surface. */
export function walletDestination(signedIn: boolean): string {
  return signedIn ? accountsUrl("/my-orders") : "/trips";
}

// The signed-in account menu rows the chrome offers (LoginPopup signed-in state). Destinations recorded
// in PORT-LEDGER-GF-001 (S3). Guest trip lookup + these are all the accounts app's own working routes.
export const ACCOUNT_LINKS: { label: string; path: string }[] = [
  { label: "My Trips", path: "/trips" },
  { label: "My Orders", path: "/my-orders" },
  { label: "My Account", path: "/account" },
];
